import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function LatestNews() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);
  const recentArticles = articles.filter((a) => !a.featured).slice(0, 6);

  return (
    <section className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-[family-name:var(--font-heading)]">
              精选内容
            </h2>
            <p className="mt-1 text-sm text-foreground-500">编辑推荐的精彩文章</p>
          </div>
          <Link
            to="/category/news"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap flex items-center gap-1 cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {recentArticles.slice(0, 3).map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}